<template>
    <v-container>
        <v-toolbar flat>
            <v-card-actions>
                <v-icon @click="$router.go(-1)" color="secondary"  style="margin-right: 10px">
                    mdi-arrow-left-thick
                </v-icon>
            </v-card-actions>
            
            <v-toolbar-title style=""><b>Subscription</b></v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>


        
        <v-form ref="form" @submit.prevent="savePackagePrice" class="custom_form">
        <v-card>

            <v-row class="custom_dash" justify="space-around">
                <v-col cols="12" md="6">
                        <v-row dense>
                            <v-col cols="6"  class="mx-15 ">
                                <b>One Time Price</b>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="6"  class="mx-4">
                               
                                 <v-text-field
                                v-model="onetimePrice"
                                outlined
                                dense 
                                clearable
                                :rules="oneTimeRules"
                                :success="oneTimeRulesSuccess" class="shrink mx-10"
                            ></v-text-field>          
                               
                            </v-col>
                        </v-row>
                </v-col> 

                <v-col cols="12" md="6">
                        <v-row dense>
                            <v-col cols="6"  class="mx-15 ">
                                <b>Monthly Price ( per month )</b>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="6"  class="mx-4">
                               
                                 <v-text-field
                                v-model="monthlyPrice"
                                outlined
                                dense 
                                clearable
                                :rules="monthlyRules"
                                :success="monthlyRulesSuccess" class="shrink mx-10"
                            ></v-text-field>          
                               
                            </v-col>
                        </v-row>

                </v-col>
            </v-row>

            <v-row v-if="errorMessage || successMessage">
                <v-col cols="6" offset-md="2">
                    <v-alert v-if="errorMessage" type="error">
                        {{errorMessage}}
                    </v-alert>
                    <v-alert v-if="successMessage" type="success">
                        {{successMessage}}
                    </v-alert>
                </v-col>
            </v-row>

              <v-divider></v-divider>
                    
                    <v-row>
                        <v-col cols="10">
                            <v-card-actions style="justify-content:center;">
                                <v-btn class="mx-5" text @click="$router.go(-1)">cancel</v-btn>
                                <v-btn
                                    class="mx-5"
                                    :disabled="disabled"
                                    type="submit"
                                    color="secondary"
                                    width="90"
                                    @click="savePackagePrice"
                                    >Submit</v-btn
                                >
                            </v-card-actions>
                        </v-col>
                    </v-row>
                    </v-card>
        </v-form>
    </v-container>
</template>



<template>
    <v-container>
        <v-toolbar flat>
            <v-card-actions>
                <v-icon @click="$router.go(-1)" color="secondary"  style="margin-right: 10px">
                    mdi-arrow-left-thick
                </v-icon>
            </v-card-actions>
            
            <v-toolbar-title style=""><b>Pop Ups</b></v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-card>
            <v-form ref="form" @submit.prevent="saveInfoMsg" class="custom_form">
                    <v-container>
                        <v-row no-gutters>
                            <v-col cols="2" align="right" class="mr-3">
                                <div class="mt-2 pr-5">
                                    <b>Title</b>
                                </div>
                            </v-col>
                            <v-col cols="6">

                                <v-text-field
                                    v-model="infoTitle"
                                    outlined
                                    dense 
                                    clearable
                                    :rules="infoTitleRules"
                                    :success="infoTitleSuccess"
                                ></v-text-field>



                            </v-col>
                        </v-row>
                        
                        <v-row no-gutters>
                            <v-col cols="2" align="right" class="mr-3">
                                <div class="mt-2 pr-5">
                                    <b>Description</b>
                                </div>
                            </v-col>
                            <v-col cols="6">

                                <v-textarea
                                v-model="infoMessage"
                                    outlined
                                    dense 
                                    clearable
                                    :rules="infoMessageRules"
                                    :success="infoMessageSuccess"
                                ></v-textarea>

                            </v-col>
                        </v-row>


                        <v-row no-gutters>
                            <v-col cols="2" align="right" class="mr-3">
                                <div class="mt-2 pr-5">
                                    <b>Time Duration</b>
                                </div>
                            </v-col>
                            <v-col cols="2">

                                <v-menu
                                    ref="menu"
                                    v-model="menu"
                                    :close-on-content-click="false"
                                    :return-value.sync="startDate"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="startDate" 
                                        outlined
                                        dense 
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                    </template>
                                    <v-date-picker
                                    v-model="startDate" :min="minDate" @click:date="setStartDateOnSecondPicker"
                                    no-title
                                    scrollable
                                    >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        text
                                        color="primary"
                                        @click="menu = false"
                                    >
                                        Cancel
                                    </v-btn>
                                    <v-btn
                                        text
                                        color="primary"
                                        @click="$refs.menu.save(startDate)"
                                    >
                                        OK
                                    </v-btn>
                                    </v-date-picker>
                                </v-menu>

                            </v-col>
                            <v-col cols="2" class = "ml-5">

                                <v-menu
                                    ref="menu1"
                                    v-model="menu1"
                                    :close-on-content-click="false"
                                    :return-value.sync="endDate"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="endDate"
                                        outlined
                                        dense 
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                    </template>
                                    <v-date-picker
                                    v-model="endDate" :min="secondMinDate"
                                    no-title
                                    scrollable
                                    >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        text
                                        color="primary"
                                        @click="menu1 = false"
                                    >
                                        Cancel
                                    </v-btn>
                                    <v-btn
                                        text
                                        color="primary"
                                        @click="$refs.menu1.save(endDate)"
                                    >
                                        OK
                                    </v-btn>
                                    </v-date-picker>
                                </v-menu>

                            </v-col>                        
                        </v-row>

                        
                        <v-row no-gutters>
                            <v-col cols="2" align="right" class="mr-3">
                                <div class="mt-2 pr-5">
                                    <b>Status</b>
                                </div>
                            </v-col>
                            <v-col cols="6">
                                <v-switch
                                    v-model="status"
                                    ref="status"
                                    inset
                                    dense
                                    class="mt-2" 
                                    color="blue"
                                    :label="status ? 'Active' : 'Inactive'"
                                >
                                <!-- @change="saveCourseStatus(item._id, item.courseStatus)" -->
                                </v-switch>
                            </v-col>
                        </v-row>


                        <v-row v-if="errorMessage || successMessage">
                            <v-col cols="6" offset-md="2">
                                <v-alert v-if="errorMessage" type="error">
                                    {{errorMessage}}
                                </v-alert>
                                <v-alert v-if="successMessage" type="success">
                                    {{successMessage}}
                                </v-alert>
                            </v-col>
                        </v-row>

                        <v-divider></v-divider>
                        
                        <v-row>
                            <v-col cols="10">
                                <v-card-actions style="justify-content:center;">
                                    <v-btn class="mx-5" text @click="$router.go(-1)">cancel</v-btn>
                                    <v-btn
                                        class="mx-5"
                                        :disabled="disabled"
                                        type="submit"
                                        color="secondary"
                                        width="90"
                                        @click="saveInfoMsg"
                                        >Submit</v-btn
                                    >
                                </v-card-actions>
                            </v-col>
                        </v-row>
                    </v-container>
            </v-form>


              <v-divider></v-divider>
              <v-form ref="form" @submit.prevent="saveExpiryMsg" class="second_form">
                    <v-container>
                          <v-row no-gutters> 
                               <v-col cols="12"  class=" text-left mr-3">
                                  <h3>Free Trial Messages</h3>
                                </v-col>
                            </v-row>
                             
                    </v-container>

                    <v-container>
                        <v-row no-gutters>
                            <v-col cols="2" align="right" class="mr-3">
                                <div class="mt-2 pr-5">
                                    <b>Set Message before Trail Expiry</b>
                                </div>
                            </v-col>
                            <v-col cols="6">

                                <v-textarea
                                v-model="expiryMsg1"
                                    outlined
                                    dense 
                                    clearable
                                    :rules="expiryMsg1Rules"
                                    :success="expiryMsg1Success"
                                ></v-textarea>



                            </v-col>
                        </v-row>
                        
                        <v-row no-gutters>
                            <v-col cols="2" align="right" class="mr-3">
                                <div class="mt-2 pr-5">
                                    <b>Set Trail Expiry Message</b>
                                </div>
                            </v-col>
                            <v-col cols="6">

                                <v-textarea
                                v-model="expiryMsg2"
                                    outlined
                                    dense 
                                    clearable
                                    :rules="expiryMsg2Rules"
                                    :success="expiryMsg2Success"
                                ></v-textarea>



                            </v-col>
                        </v-row>
             

                        <v-row v-if="errorMessage1 || successMessage1">
                            <v-col cols="6" offset-md="2">
                                <v-alert v-if="errorMessage1" type="error">
                                    {{errorMessage1}}
                                </v-alert>
                                <v-alert v-if="successMessage1" type="success">
                                    {{successMessage1}}
                                </v-alert>
                            </v-col>
                        </v-row>

                        <v-divider></v-divider>
                        
                        <v-row>
                            <v-col cols="10">
                                <v-card-actions style="justify-content:center;">
                                    <v-btn class="mx-5" text @click="$router.go(-1)">cancel</v-btn>
                                    <v-btn
                                        class="mx-5"
                                        :disabled="disabled"
                                        type="submit"
                                        color="secondary"
                                        width="90"
                                        @click="saveExpiryMsg"
                                        >Submit</v-btn
                                    >
                                </v-card-actions>
                            </v-col>
                        </v-row>
                    </v-container>
            </v-form>
        </v-card>
       
    </v-container>
</template>




<script>
//import Course from "../../models/Course";
//import {mapMutations } from "vuex";
import axios from "axios";
import url1 from "../../../config.js";

export default {
     beforeRouteEnter(to, from, next) {
        next(vm => {
            setTimeout(() => {
                if (!vm.$store.state.auth.adminUser._id)
                   vm.$router.push("/");
            }, 0);
        });
    },
    name: "ReminderPopup",
    data() {
        return {

            id: "",
            startDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            endDate:"",
            //minDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            minDate: new Date().toISOString().slice(0,10),
            secondMinDate: new Date().toISOString().slice(0,10),
            menu: false,
            menu1: false,
            
            infoTitle: "",
            infoMessage: "",

            /** for free trail expiry messages */
            mess_id1: "",
            mess_id2: "",
            expiryMsg1: "",
            expiryMsg2: "",


            status:false,
            url: url1.url,
            successMessage:'',
            errorMessage:'',

            successMessage1:'',
            errorMessage1:'',

            disabled:false,

            infoTitleSuccess: false,
            infoTitleRules: [
                v => {
                    if (v) {
                        this.infoTitleRulesSuccess = true;
                        return true;
                    } else {
                        this.infoTitleRulesSuccess = false;
                        return "Title is required";
                    }
                },
                v => (v || "").length >= 2 || "Title must be at least 2 characters long", //to ask for the models
            ],


            infoMessageSuccess: false,
            infoMessageRules: [
                v => {
                    if (v) {
                        this.infoMessageRulesSuccess = true;
                        return true;
                    } else {
                        this.infoMessageRulesSuccess = false;
                        return "Message is required";
                    }
                },
                v => (v || "").length >= 2 || "Message must be at least 2 characters long", //to ask for the models
            ],


            expiryMsg1Success: false,
            expiryMsg1Rules: [
                v => {
                    if (v) {
                        this.expiryMsg1RulesSuccess = true;
                        return true;
                    } else {
                        this.expiryMsg1RulesSuccess = false;
                        return "Message is required";
                    }
                },
                v => (v || "").length >= 2 || "Message must be at least 2 characters long", //to ask for the models
            ],



            expiryMsg2Success: false,
            expiryMsg2Rules: [
                v => {
                    if (v) {
                        this.expiryMsg2RulesSuccess = true;
                        return true;
                    } else {
                        this.expiryMsg2RulesSuccess = false;
                        return "Message is required";
                    }
                },
                v => (v || "").length >= 2 || "Message must be at least 2 characters long", //to ask for the models
            ],




        }
    },
    computed: {
        auth() {
            return this.$store.state.auth;
        },

       /* setMinDateForSecondPicker() {
            var endDate = new Date(this.date.getFullYear(), this.date.getMonth() + 1, 10);
            return endDate.toISOString().slice(0,10)
        } */
       
    },


    methods: {

        setStartDateOnSecondPicker (date) {

           // alert(`You have just double clicked the following date: ${date}`)
            const d = new Date(date);
            console.log('set secondd date', d);
            this.secondMinDate =  d.toISOString().substr(0, 10);
        },

        saveInfoMsg() {
            this.disabled = true;
            //console.log('title', this.course.courseTitle);
            if (this.infoTitle.trim().length === 0)
            {
                this.errorMessage = 'Title should be valid';
                setTimeout(() => (this.errorMessage = ""), 5000);
                this.disabled = false;
                return;
            }

            if (this.infoMessage.trim().length === 0 ) 
            {
                this.errorMessage = 'Message should be valid';
                setTimeout(() => (this.errorMessage = ""), 5000);
                this.disabled = false;
                return;
            }            

            if (this.endDate.trim().length === 0 )
            {
                this.errorMessage = 'Please select End date';
                setTimeout(() => (this.errorMessage = ""), 5000);
                this.disabled = false;
                return;
            }            


                 axios
                    .post(
                        this.url+"/api/popups/update",
                        {
                            id: this.id,
                            title: this.infoTitle,
                            message: this.infoMessage,
                            startDate: this.startDate,
                            endDate: this.endDate,
                            status: this.status,


                        },
                        {
                            headers: { "x-auth-token": this.auth.token }
                        }
                    )
                    .then(res => {
                        console.log("save package", res);
                        if(res.data.success){
                           this.successMessage = res.data.message;
                            setTimeout(() => ( this.successMessage = ""), 5000);
                        }else{
                           this.errorMessage = res.data.message;
                            setTimeout(() => ( this.errorMessage = ""), 5000);

                        }


                        this.disabled = false;
                        return;
                    })
                    .catch(err => {
                        console.error(err.message);
                        this.disabled = false;
                        this.errorMessage = 'Some error occured while updating message. Please try again';
                        setTimeout(() => (this.errorMessage = ""), 5000);
                        this.disabled = false;
                        return;
        

                    });

           /*  Course.postCourse( this.course, this.auth.token)
            .then( res => {
                this.disabled = false;
                console.log('res', res);
                this.successMessage = 'Course added successfully';
                setTimeout(() => (this.successMessage = ""), 5000);
                this.$refs.form.reset();
            })
            .catch( err => {
                this.errorMessage = err.response.data;
                setTimeout(() => (this.errorMessage = ""), 5000);
                this.disabled = false;
                this.$refs.form.reset(); 
            }); */
        },


    saveExpiryMsg() {
            this.disabled = true;
            //console.log('title', this.course.courseTitle);
            if (this.expiryMsg1.trim().length === 0)
            {
                this.errorMessage1 = 'Message should be valid';
                setTimeout(() => (this.errorMessage1 = ""), 5000);
                this.disabled = false;
                return;
            }

            if (this.expiryMsg2.trim().length === 0 ) 
            {
                this.errorMessage1 = 'Message should be valid';
                setTimeout(() => (this.errorMessage1 = ""), 5000);
                this.disabled = false;
                return;
            }            



                 axios
                    .post(
                        this.url+"/api/popups/freetrial/update",
                        {
                            mess_id1: this.mess_id1,
                            mess_id2: this.mess_id2,
                            mess1: this.expiryMsg1,
                            mess2: this.expiryMsg2,


                        },
                        {
                            headers: { "x-auth-token": this.auth.token }
                        }
                    )
                    .then(res => {
                        console.log("save expiry mess", res);
                        if(res.data.success){
                           this.successMessage1 = res.data.message;
                            setTimeout(() => ( this.successMessage1 = ""), 5000);
                        }else{
                           this.errorMessage1 = res.data.message;
                            setTimeout(() => ( this.errorMessage1 = ""), 5000);

                        }


                        this.disabled = false;
                        return;
                    })
                    .catch(err => {
                        console.error(err.message);
                        this.disabled = false;
                        this.errorMessage = 'Some error occured while updating message. Please try again';
                        setTimeout(() => (this.errorMessage = ""), 5000);
                        this.disabled = false;
                        return;
        

                    });

        },
        getInfoPoup() {
            axios
                .get(
                    this.url+"/api/popups/list",
                    {
                            headers: { "x-auth-token": this.auth.token }
                    }
                )
                .then(
                    res => {
                        console.log(res.data);
                        this.id = res.data.data._id;
                        this.infoTitle = res.data.data.title;
                        this.infoMessage = res.data.data.message;
                        this.startDate = res.data.data.startDate;
                        this.endDate = res.data.data.endDate;
                        this.status = res.data.data.status;
                    },
                    err => {
                        console.log(err);
                    }
                )
                .catch(err => {
                    console.error(err);
                });
        },

    getExpiryPopup() {
            axios
                .get(
                    this.url+"/api/popups/freetrial/list",
                    {
                            headers: { "x-auth-token": this.auth.token }
                    }
                )
                .then(
                    res => {
                        console.log(res.data);
                        this.mess_id1 = res.data.data.mess_id1;
                        this.mess_id2 = res.data.data.mess_id2;

                        this.expiryMsg1 = res.data.data.mess1;
                        this.expiryMsg2 = res.data.data.mess2;
                    },
                    err => {
                        console.log(err);
                    }
                )
                .catch(err => {
                    console.error(err);
                });
        },

        clearForm(){
            this.$refs.form.resetValidation();
        },

    }, 
    mounted(){
        this.getInfoPoup()
        this.getExpiryPopup()
    }
}
</script>
<style scoped>
form.v-form.custom_form{
    margin: 10px 0 0;
    border-top:none;
}
.custom_form >>> .v-card {
    padding-top: 20px;
}
</style>